import React from "react";
import "./PreBookStock.scss";
import {MDBProgress} from "mdbreact";
import {numberFormat} from "../../util";
import {assetUrl} from "../../serviceApi";

const ProfileIcon = assetUrl+"images/profile-icon.svg";
const StockClock = assetUrl+"images/stock-clock.svg";


function PreBookStock(props){
    const {selected_stock,
        // submit,handleRadioInputs,order_mode,
        handleQtyChange,quantity} = props;
    return(
        <div className={"pre-book-stock-component"}>
            <div className={"d-flex justify-content-between"}>
                <div className={"d-flex"}>
                    <div className={"image-section"}>
                        <img src={selected_stock.politicianImage?selected_stock.politicianImage:ProfileIcon} alt={"StockProfile"} className={"img-fluid stock-profile"}/>
                        <img src={StockClock} alt={"StockClock"} className={"clock-image"}/>
                    </div>
                    <div className={"stock-description"}>
                        <p className={"stock-name"}>{selected_stock.name}</p>
                        <p className={"party-name"}>{selected_stock.party?selected_stock.party.partyName:""}</p>
                    </div>
                </div>
                <div>
                    <p className={"stock-price text-right"}>{numberFormat(selected_stock.price)}</p>
                </div>
            </div>
            <p className={"stock-left mb-2"}><span style={{fontWeight: 700}}>{selected_stock.upcomingStocksSubscribed}/{selected_stock.upcomingStocks}</span> Shares Left</p>
	        <div className={"progress-bg"}>
		        <MDBProgress value={(100-selected_stock.upcomingStocksPercentage)} className="" />
	        </div>
            <div className={"divider"}/>
            <div className={"text-center"}>
                <p className={"price-per-share"}>SET share QUANTITY</p>
                <form>
                    <input type="number"
                           className="form-control quantity-input"
                           value={quantity}
                           onChange={(e)=>handleQtyChange(e,"quantity")}
                    />
                </form>
                <p className={"subscribe-text"}>Do you want to subscribe?</p>

                <p className={"share-description"}>
                    You will be subscribing to {quantity} shares of {selected_stock.name}
                </p>
            </div>
            {/*<div className={"total-footer d-flex align-items-center justify-content-between"}>*/}
            {/*    <div>*/}
            {/*        <div className={"d-flex align-items-center"}>*/}
            {/*            <p className={"estimate-total-content"}>EST. TOTAL</p>*/}
            {/*            <img src={InfoIcon} alt={"InfoIcon"}/>*/}
            {/*        </div>*/}
            {/*        <p className={"estimate-total"}>₹ {selected_stock.price * quantity}</p>*/}
            {/*    </div>*/}
            {/*    <button type={"button"} className={"btn submit-btn"} onClick={submit}>*/}
            {/*        Pre-Book*/}
            {/*        <img src={icon_forward_white} alt={"icon_forward_white"} className={"arrow-right"}/>*/}
            {/*    </button>*/}
            {/*</div>*/}
        </div>
    );
}

export default PreBookStock;
